// extracted by mini-css-extract-plugin
module.exports = {"sentinel":"top-navigation_sentinel__4Yr8V","wrapper":"top-navigation_wrapper__zHxdA"};